import { Card, Button } from "@mui/material";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState, useEffect, useCallback } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import DownloadIcon from "@mui/icons-material/Download";
import { useApiUrl } from "@refinedev/core";
import CloseTicket from "./closeTicket";
import { dataProvider } from "rest-data-provider";
import PlatFormType from "@warriortrading/warriortrading.hermes.common.feathers/enums/platformType";
import BrowserType from "@warriortrading/warriortrading.hermes.common.feathers/enums/browserType";
import SiteSourceType from "@warriortrading/warriortrading.hermes.common.feathers/enums/siteSourceType";
import OsType from "@warriortrading/warriortrading.hermes.common.feathers/enums/osType";
import ConnectionType from "@warriortrading/warriortrading.hermes.common.feathers/enums/connectionType";

export const TicketsEdit = () => {
    const {
        refineCore: { queryResult },
    } = useForm();
    const dataTotal = queryResult?.data?.data;

    const apiUrl = useApiUrl();
    const [emailData, setEmailData] = useState<null | string>(null);
    const emailDataFun = useCallback((reporterId: string) => {
        return dataProvider(apiUrl)
        .getList({resource: "user/profile", filters: [{ field: "id", operator: "eq", value: reporterId}]})
        .then((res) => {
            if (res?.data) {
                const data = res?.data as any;
                setEmailData(data?.email);
            }
            const data = res?.data as any;
            return data?.email;
        });
    }, [apiUrl]);

    useEffect(() => {
        if (dataTotal?.reporterId) {
            emailDataFun(dataTotal?.reporterId);
        }
    }, [dataTotal, emailDataFun]);

    const [screenshotUrls, setScreenshotUrls] = useState([]);
    useEffect(() => {
        const attachmentUrls = dataTotal?.attachmentUrls;
        try {
            JSON.parse(attachmentUrls);
            setScreenshotUrls(JSON.parse(attachmentUrls)?.screentShots);
          } catch (e) {
          }
    }, [dataTotal?.attachmentUrls]);

    const closeTicket = (id: any) => {
        setIsOpen(true);
        setId(id);
    }
    const [isOpen, setIsOpen] = useState(false);
    const [id, setId] = useState("");
    const handleClose = () => {
        setIsOpen(false);
    }
    return (
        <Edit saveButtonProps={{style: {display: "none"}}}>
            {
                dataTotal ? <Card>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Ticket Info
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div style={{ display: "flex", justifyContent: "space-around", marginTop: "10px", paddingTop: "20px", paddingLeft: "20px", paddingRight: "20px" }}>
                    <Card style={{marginRight: "20px", width: "56vw"}}>
                        <AppBar position="static">
                            <div style={{width: "550px", padding: "10px", display: "flex"}}>
                                <DownloadIcon />
                                <a
                                    href={dataTotal?.logUrl as string}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ width: "200px", marginRight: "10px" }}
                                >
                                    Download the log file
                                </a>
                                {
                                    `committed by ${dataTotal?.["reporter.nickname"]} (${emailData}) at ${dataTotal?.createdAt}`
                                }
                            </div>
                        </AppBar>
                        <div style={{marginTop: "20px", marginLeft: "22px"}}>
                            {
                                `${dataTotal?.title}`
                            }
                        </div>
                        <div style={{marginTop: "20px", marginLeft: "22px", marginBottom: "20px"}}>
                            {
                                `${dataTotal?.content}`
                            }
                        </div>
                    </Card>
                    <Card style={{paddingLeft: "30px", paddingRight: "40px", paddingBottom: "20px"}}>
                        <h3>System info</h3>
                        <div>
                            {
                                `OS: ${OsType.fromValue(dataTotal?.os)?.name} ~ ${dataTotal?.osVersion}`
                            }
                        </div>
                        <div>
                            {
                                `Browser: ${BrowserType.fromValue(dataTotal?.browser)?.name} ~ ${dataTotal?.browserVersion}`
                            }
                        </div>
                        <div>
                            {
                                `platform: ${PlatFormType.fromValue(dataTotal?.platform)?.name}`
                            }
                        </div>
                        <div>
                            {
                                `SourceType: ${SiteSourceType.fromValue(dataTotal?.sourceType)?.name}`
                            }
                        </div>
                        <h3>Internet info</h3>
                        <div>
                            {
                                `TestSpeed: ping: ${dataTotal?.testSpeed.split("_")[0]} ~ down: ${dataTotal?.testSpeed.split("_")[1]} ~ up: ${dataTotal?.testSpeed.split("_")[2]}~`
                            }
                        </div>
                        <div>
                            {
                                `ConnectionType: ${ConnectionType.fromValue(dataTotal?.connectionType)?.name}`
                            }
                        </div>
                        <div>
                            {
                                `IpV4: ${dataTotal?.ipV4}`
                            }
                        </div>
                        {
                            dataTotal?.hasAttachments? <div>
                                <h3>Attachments</h3>
                                <a
                                    href={screenshotUrls.length !== 0 ?  screenshotUrls[0] : "" as string}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Click this link to preview the attachment
                                </a>
                            </div> : null
                        }
                    </Card>
                </div>
                { isOpen ? <CloseTicket isOpen={isOpen} id={id} handleClose={handleClose}/> : null}
                <Button variant="outlined" style={{margin: "20px"}} onClick={() => closeTicket(dataTotal?.id)}>CLOSE TICKET</Button>
            </Card> : null
            }
        </Edit>
   );
};
